module.exports = __webpack_public_path__ + "3b18e60a4349bfa2eafa009a9467091f.svg";